import { BrowserRouter, type BrowserRouterProps } from 'react-router-dom'

const Router = (props: BrowserRouterProps) => <BrowserRouter {...props} />

export default Router
